'use client';

import { c as _c } from "react/compiler-runtime";
import { Bar, BarChart, CartesianGrid, Cell, ResponsiveContainer, Tooltip, XAxis, YAxis } from 'recharts';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { ContentCard, CardTitle, CardText } from './shared';
const BAR_COLORS = ['#93C5FD', '#60A5FA', '#3B82F6', '#2563EB'] as const;
export function HowItWorksRolloutChart() {
  const $ = _c(79);
  const chart = useCadrinoCopy().howItWorks.rolloutChart;
  let T0;
  let T1;
  let T2;
  let T3;
  let t0;
  let t1;
  let t10;
  let t11;
  let t12;
  let t13;
  let t14;
  let t15;
  let t16;
  let t17;
  let t18;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let t7;
  let t8;
  let t9;
  if ($[0] !== chart.phases || $[1] !== chart.progressLabel || $[2] !== chart.subtitle || $[3] !== chart.title) {
    const data = chart.phases.map(_temp);
    T3 = ContentCard;
    t15 = "mt-8";
    t16 = chart.title;
    if ($[27] !== chart.title) {
      t17 = <CardTitle className="text-base">{chart.title}</CardTitle>;
      $[27] = chart.title;
      $[28] = t17;
    } else {
      t17 = $[28];
    }
    if ($[29] !== chart.subtitle) {
      t18 = <CardText className="mt-2">{chart.subtitle}</CardText>;
      $[29] = chart.subtitle;
      $[30] = t18;
    } else {
      t18 = $[30];
    }
    t14 = "mt-5 h-[220px] w-full";
    T2 = ResponsiveContainer;
    t12 = "100%";
    t13 = "100%";
    T1 = BarChart;
    t4 = data;
    t5 = "vertical";
    if ($[31] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = {
        top: 4,
        right: 8,
        left: 0,
        bottom: 4
      };
      $[31] = t6;
    } else {
      t6 = $[31];
    }
    t7 = "22%";
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
      t8 = <CartesianGrid strokeDasharray="3 3" horizontal={false} stroke="#E2E8F0" />;
      $[32] = t8;
    } else {
      t8 = $[32];
    }
    if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
      t9 = <XAxis type="number" domain={[0, 100]} tick={{
        fontSize: 11,
        fill: "#64748B"
      }} tickFormatter={_temp2} axisLine={false} tickLine={false} />;
      $[33] = t9;
    } else {
      t9 = $[33];
    }
    let t19;
    if ($[34] !== chart.phases) {
      t19 = langWidth(chart.phases);
      $[34] = chart.phases;
      $[35] = t19;
    } else {
      t19 = $[35];
    }
    let t20;
    if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
      t20 = {
        fontSize: 12,
        fill: "#334155"
      };
      $[36] = t20;
    } else {
      t20 = $[36];
    }
    if ($[37] !== t19) {
      t10 = <YAxis type="category" dataKey="shortLabel" width={t19} tick={t20} axisLine={false} tickLine={false} />;
      $[37] = t19;
      $[38] = t10;
    } else {
      t10 = $[38];
    }
    let t21;
    let t22;
    if ($[39] === Symbol.for("react.memo_cache_sentinel")) {
      t21 = {
        fill: "rgba(59, 130, 246, 0.06)"
      };
      t22 = {
        borderRadius: 12,
        border: "1px solid #E2E8F0",
        fontSize: 12
      };
      $[39] = t21;
      $[40] = t22;
    } else {
      t21 = $[39];
      t22 = $[40];
    }
    if ($[41] !== chart.progressLabel) {
      t11 = <Tooltip cursor={t21} contentStyle={t22} formatter={value => [`${Number(value ?? 0)}%`, chart.progressLabel]} labelFormatter={_temp3} />;
      $[41] = chart.progressLabel;
      $[42] = t11;
    } else {
      t11 = $[42];
    }
    T0 = Bar;
    t0 = "value";
    if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
      t1 = [0, 6, 6, 0];
      $[43] = t1;
    } else {
      t1 = $[43];
    }
    t2 = 22;
    t3 = data.map((__0, index_0) => <Cell key={data[index_0].shortLabel} fill={BAR_COLORS[index_0] ?? BAR_COLORS[3]} />);
    $[0] = chart.phases;
    $[1] = chart.progressLabel;
    $[2] = chart.subtitle;
    $[3] = chart.title;
    $[4] = T0;
    $[5] = T1;
    $[6] = T2;
    $[7] = T3;
    $[8] = t0;
    $[9] = t1;
    $[10] = t10;
    $[11] = t11;
    $[12] = t12;
    $[13] = t13;
    $[14] = t14;
    $[15] = t15;
    $[16] = t16;
    $[17] = t17;
    $[18] = t18;
    $[19] = t2;
    $[20] = t3;
    $[21] = t4;
    $[22] = t5;
    $[23] = t6;
    $[24] = t7;
    $[25] = t8;
    $[26] = t9;
  } else {
    T0 = $[4];
    T1 = $[5];
    T2 = $[6];
    T3 = $[7];
    t0 = $[8];
    t1 = $[9];
    t10 = $[10];
    t11 = $[11];
    t12 = $[12];
    t13 = $[13];
    t14 = $[14];
    t15 = $[15];
    t16 = $[16];
    t17 = $[17];
    t18 = $[18];
    t2 = $[19];
    t3 = $[20];
    t4 = $[21];
    t5 = $[22];
    t6 = $[23];
    t7 = $[24];
    t8 = $[25];
    t9 = $[26];
  }
  let t19;
  if ($[44] !== T0 || $[45] !== t0 || $[46] !== t1 || $[47] !== t2 || $[48] !== t3) {
    t19 = <T0 dataKey={t0} radius={t1} maxBarSize={t2}>{t3}</T0>;
    $[44] = T0;
    $[45] = t0;
    $[46] = t1;
    $[47] = t2;
    $[48] = t3;
    $[49] = t19;
  } else {
    t19 = $[49];
  }
  let t20;
  if ($[50] !== T1 || $[51] !== t10 || $[52] !== t11 || $[53] !== t19 || $[54] !== t4 || $[55] !== t5 || $[56] !== t6 || $[57] !== t7 || $[58] !== t8 || $[59] !== t9) {
    t20 = <T1 data={t4} layout={t5} margin={t6} barCategoryGap={t7}>{t8}{t9}{t10}{t11}{t19}</T1>;
    $[50] = T1;
    $[51] = t10;
    $[52] = t11;
    $[53] = t19;
    $[54] = t4;
    $[55] = t5;
    $[56] = t6;
    $[57] = t7;
    $[58] = t8;
    $[59] = t9;
    $[60] = t20;
  } else {
    t20 = $[60];
  }
  let t21;
  if ($[61] !== T2 || $[62] !== t12 || $[63] !== t13 || $[64] !== t20) {
    t21 = <T2 width={t12} height={t13}>{t20}</T2>;
    $[61] = T2;
    $[62] = t12;
    $[63] = t13;
    $[64] = t20;
    $[65] = t21;
  } else {
    t21 = $[65];
  }
  let t22;
  if ($[66] !== t14 || $[67] !== t21) {
    t22 = <div className={t14}>{t21}</div>;
    $[66] = t14;
    $[67] = t21;
    $[68] = t22;
  } else {
    t22 = $[68];
  }
  let t23;
  if ($[69] !== chart.footnote) {
    t23 = <p className="mt-4 border-t border-slate-100 pt-4 text-xs leading-relaxed text-cadrino-muted">{chart.footnote}</p>;
    $[69] = chart.footnote;
    $[70] = t23;
  } else {
    t23 = $[70];
  }
  let t24;
  if ($[71] !== T3 || $[72] !== t15 || $[73] !== t16 || $[74] !== t17 || $[75] !== t18 || $[76] !== t22 || $[77] !== t23) {
    t24 = <T3 className={t15} aria-label={t16}>{t17}{t18}{t22}{t23}</T3>;
    $[71] = T3;
    $[72] = t15;
    $[73] = t16;
    $[74] = t17;
    $[75] = t18;
    $[76] = t22;
    $[77] = t23;
    $[78] = t24;
  } else {
    t24 = $[78];
  }
  return t24;
}
function _temp3(_, payload) {
  const row = payload?.[0]?.payload as {
    step?: string;
    shortLabel?: string;
  } | undefined;
  return row?.step && row?.shortLabel ? `${row.step} · ${row.shortLabel}` : "";
}
function _temp2(v) {
  return `${v}%`;
}
function _temp(phase, index) {
  return {
    ...phase,
    step: String(index + 1).padStart(2, "0")
  };
}
function langWidth(phases: {
  shortLabel: string;
}[]): number {
  const longest = phases.reduce((max, p) => Math.max(max, p.shortLabel.length), 0);
  return Math.min(96, Math.max(64, longest * 7));
}